import axios from "../httpHandler";

export const getStores = async (filters) => {
  try {
    const result = await axios.get(`warehouse${filters}`);
    return result?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getBuyHistory = async (inputId, allItems = true) => {
  try {
    const allItemsQuery = allItems ? 'all_items=true' : '';
    const query = `?input_id=${inputId}&${allItemsQuery}`;
    const result = await axios.get(`warehouse/history${query}`);
    return result?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
